'use client'

import * as React from 'react'
import { Menu, X, ArrowUpRightIcon } from 'lucide-react'
import Link from 'next/link'
import Image from 'next/image'
import { Button } from '@/components/ui/button'
import { SignedIn, SignedOut, UserButton } from '@clerk/nextjs'

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#1c2333] bg-[#07090f]/80 backdrop-blur-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link href="/" aria-label="TidyCalls Logo">
          <Image
            height={26}
            width={100}
            src="https://res.cloudinary.com/dyf0ydr0a/image/upload/f_auto,q_auto,w_100/TidyCalls-Logo-2025_merksm.png"
            alt="TidyCalls Logo"
            className="brightness-0 invert"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          <Link
            href="/#solutions"
            className="text-sm text-[#94a3b8] hover:text-[#e2e8f0] transition-colors"
          >
            Solutions
          </Link>
          <Link
            href="/#proof"
            className="text-sm text-[#94a3b8] hover:text-[#e2e8f0] transition-colors"
          >
            Proof
          </Link>
          <Link
            href="/contact"
            className="text-sm text-[#94a3b8] hover:text-[#e2e8f0] transition-colors"
          >
            Contact
          </Link>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <SignedOut>
            <Link href="/contact">
              <Button
                size="sm"
                className="bg-[#00c8ff] text-[#07090f] font-semibold hover:bg-[#00b8ef] transition-colors"
              >
                Book a Demo <ArrowUpRightIcon className="ml-1 h-3.5 w-3.5" />
              </Button>
            </Link>
          </SignedOut>
          <SignedIn>
            <Link href="/dashboard">
              <Button
                size="sm"
                variant="outline"
                className="border-[#1c2333] text-[#e2e8f0] hover:bg-[#0d1117]"
              >
                Dashboard <ArrowUpRightIcon className="ml-1 h-3.5 w-3.5" />
              </Button>
            </Link>
            <UserButton />
          </SignedIn>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden text-[#94a3b8] hover:text-[#e2e8f0]"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Mobile nav */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-[#1c2333] bg-[#07090f] px-4 py-6 flex flex-col gap-6">
          <Link
            href="/#solutions"
            className="text-sm text-[#94a3b8]"
            onClick={() => setIsMenuOpen(false)}
          >
            Solutions
          </Link>
          <Link
            href="/#proof"
            className="text-sm text-[#94a3b8]"
            onClick={() => setIsMenuOpen(false)}
          >
            Proof
          </Link>
          <Link
            href="/contact"
            className="text-sm text-[#94a3b8]"
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
          <SignedOut>
            <Link href="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button
                size="sm"
                className="w-full bg-[#00c8ff] text-[#07090f] font-semibold"
              >
                Book a Demo
              </Button>
            </Link>
          </SignedOut>
          <SignedIn>
            <Link href="/dashboard" onClick={() => setIsMenuOpen(false)}>
              <Button
                size="sm"
                variant="outline"
                className="w-full border-[#1c2333] text-[#e2e8f0]"
              >
                Dashboard
              </Button>
            </Link>
          </SignedIn>
        </div>
      )}
    </header>
  )
}
